const steps = [
  {
    n: "01",
    title: "Onboard in a weekend",
    body: "Our Ohio team migrates your families, staff, and active DCY 01234 records. You keep working.",
  },
  {
    n: "02",
    title: "Turn on the modules you need",
    body: "Enrollment, billing, parent app, staff app — go live one at a time or all at once.",
  },
  {
    n: "03",
    title: "Stay audit-ready automatically",
    body: "Ratios, forms, training logs, and incident reports file themselves in the right place.",
  },
  {
    n: "04",
    title: "Grow without re-buying software",
    body: "Add a second location — or a tenth — without a new license or re-implementation.",
  },
];

export const HowItWorks = () => {
  return (
    <section data-testid="how-it-works-section" className="py-24 sm:py-32 bg-stone-50 relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-stone-200 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-emerald-700">
            How it works
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-medium text-stone-900 tracking-tight">
            From binder chaos to calm — in four steps.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {steps.map((s, i) => (
            <div key={s.n} data-testid={`step-${i}`} className="relative">
              <div className="font-display text-[7rem] leading-none font-light text-stone-200 select-none">
                {s.n}
              </div>
              <div className="mt-[-2rem] relative">
                <h3 className="font-display text-xl font-medium text-stone-900">{s.title}</h3>
                <p className="mt-3 text-sm text-stone-600 leading-relaxed max-w-xs">{s.body}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-[3.5rem] right-[-2rem] w-16 h-px bg-stone-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
